<template>
    <div class="login_modal_box">
        <b-modal ref="modal" @show="show = true" @hide="hide" id="login_modal" hide-footer centered title="會員登入">
            <form>
                <div class="login_content">
                    <h4 class="text-center">
                        歡迎回來，最新的課程等著你來探索體驗
                    </h4>
                    <div class="enter_box">
                        <input v-model="account" type="text" placeholder="請輸入手機號碼" v-validate="'required'" name="account">
                        <input v-model="password" type="password" placeholder="請輸入密碼" v-validate="'required'" name="password">
                    </div>
                    <div class="rber_box row justify-content-between">
                        <div class="col-6">
                            <input id="rber_check" type="checkbox" name="rber_check">
                            <label for="rber_check">
                                記得我
                            </label>
                        </div>
                        <div class="col-6 text-right">
                            <a :href="forgetPwdUrl" target="_blank">
                                忘記密碼
                            </a>
                        </div>
                    </div>
                </div>
                <div slot="modal-footer" class="modal_footer">
                    <div class="text-center">
                        <b-btn @click="login()" class="hoverFill">
                            登入
                        </b-btn>
                        <a class="btn hoverFill btn-secondary" :href="registerUrl" target="_blank">
                            註冊
                        </a>
                        <p class>
                            如您還未成為愛家卡會員或尚未開通愛家卡線上服務，請按註冊進行申辦
                        </p>
                    </div>
                    <div class="errors_box">
                        <span>{{ errors.first('account') }}</span>
                        <span>{{ errors.first('password') }}</span>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import { mapMutations, mapGetters } from 'vuex';
    import accountApi from '@/api/account';

    export default {
        // name: 'LoginModal',
        data() {
            return {
                account: null,
                password: null,
                show: false,
            }
        },
        computed: {
            ...mapGetters('user', ['showModal']),
            ...mapGetters('home', [
              'forgetPwdUrl',
              'registerUrl',
            ]),
        },
        watch: {
            showModal(val) {
                if (val && !this.show) {
                    this.$refs.modal.show()
                }
            },
            password(val) {
              this.password = val.toLowerCase();
            }
        },
        created() {
            let attributes = {
                account: '手機號碼',
                password: '密碼',
            };

            const dict = {
                attributes,
            };

            this.$validator.localize('zh_TW', dict);
        },
        methods: {
            ...mapMutations('user', [
                'setUser',
                'setShowModal'
            ]),
            hide() {
                this.show = false
                this.setShowModal(false);
            },
            login() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        accountApi.login({
                            Account: this.account,
                            LoginKey: this.password,
                            companyId: 'B0',
                        }, (data) => {
                            this.setUser(data);
                            window.location.reload();
                            // this.$refs.modal.hide();
                        }, () => {
                            alert('登入失敗');
                        });
                        
                        return;
                    }
                });
            },
        }
    }
</script>
